import React, {useContext} from 'react';
import OutputLine from "./OutputLine";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import escapeOutputString from "../../../misc/escapeOutputString";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const HeaderShortTitleOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);
	return (
		configuratorStore.headerShortTitle ?
			<OutputLine indent={baseIndent} highlightableField="headerShortTitle">
				{`headerShortTitle: '${escapeOutputString(configuratorStore.headerShortTitle)}',`}
			</OutputLine>
			: null
	);
};

HeaderShortTitleOutput.propTypes = propTypes;
HeaderShortTitleOutput.defaultProps = defaultProps;

export default observer(HeaderShortTitleOutput);
